import React from 'react';
import PropTypes from 'prop-types';
import { OnVisible } from '@americanexpress/data-manager-utils';
import MarketingTile from '../MarketingTile/MarketingTile';
import RenderEarlyTenureOrHomeTopColumnTile
  from '../RenderEarlyTenureOrHomeTopColumnTile/RenderEarlyTenureOrHomeTopColumnTile';

const SideTiles = ({
  topColumnTile, bottomColumnTile, cardType,
}) => (
  <>
    <div className="col-md-6 margin-4-b pad-2-lr-sm-down pad-3-l-md-up pad-1-r-md-up">
      <RenderEarlyTenureOrHomeTopColumnTile
        travelHomeTopColumnTileContent={topColumnTile}
        cardType={cardType}
      />
    </div>
    <div className="col-md-6 margin-4-b pad-2-lr-sm-down pad-1-l-md-up pad-3-r-md-up">
      <MarketingTile index={2} content={bottomColumnTile} />
    </div>
    <OnVisible
      analyticsInfo={{
        element: `hp-${cardType}`,
        detail: 'hp-tiles-L1-banner-hp-tiles-L2-banner',
      }}
    >
      <span />
    </OnVisible>
  </>
);

SideTiles.propTypes = {
  topColumnTile: PropTypes.shape({
    analyticIdentifier: PropTypes.string,
  }).isRequired,
  bottomColumnTile: PropTypes.shape({
    analyticIdentifier: PropTypes.string,
  }).isRequired,
  cardType: PropTypes.string.isRequired,
};

export default SideTiles;
